/* eslint-disable import/no-anonymous-default-export */
import { SET_TOKEN } from "./actionTypes";

const initialState: any = {
  token: null,
  refreshToken: null,
};

export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload.access_token,
        refreshToken: action.payload.refresh_token,
      };
    default:
      return {
        ...state,
      };
  }
};
